import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { registerUser, checkAvailability } from '../api';
import { useAuth } from '../context/AuthContext';
import toast from 'react-hot-toast';
import { FiUser, FiMail, FiLock, FiPhone, FiEye, FiEyeOff, FiCheck, FiX } from 'react-icons/fi';
import './Auth.css';

const SignUp = () => {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({
    username: '', email: '', first_name: '', last_name: '', phone: '', password: '',
  });
  const [showPw, setShowPw] = useState(false);
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const [availability, setAvailability] = useState({});

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm({ ...form, [name]: value });
    setErrors({ ...errors, [name]: '' });
  };

  const checkField = async (field) => {
    if (!form[field]) return;
    try {
      const { data } = await checkAvailability({ [field]: form[field] });
      const key = `${field}_available`;
      setAvailability((prev) => ({ ...prev, [field]: data[key] }));
    } catch {}
  };

  const validate = () => {
    const e = {};
    if (!form.username) e.username = 'Required';
    else if (availability.username === false) e.username = 'Username already taken';
    if (!form.email) e.email = 'Required';
    else if (!/\S+@\S+\.\S+/.test(form.email)) e.email = 'Invalid email';
    else if (availability.email === false) e.email = 'Email already in use';
    if (!form.password) e.password = 'Required';
    else if (form.password.length < 6) e.password = 'At least 6 characters';
    return e;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const errs = validate();
    if (Object.keys(errs).length) { setErrors(errs); return; }
    setLoading(true);
    try {
      await registerUser(form);
      await login({ username: form.username, password: form.password });
      toast.success('Account created! Welcome to DJI Nepal.');
      navigate('/');
    } catch (err) {
      const data = err.response?.data || {};
      const mapped = {};
      Object.keys(data).forEach((k) => { mapped[k] = Array.isArray(data[k]) ? data[k][0] : data[k]; });
      setErrors(mapped);
    } finally {
      setLoading(false);
    }
  };

  const AvailIcon = ({ field }) => {
    if (availability[field] === true) return <FiCheck style={{ color: '#00c850' }} />;
    if (availability[field] === false) return <FiX style={{ color: 'var(--dji-red)' }} />;
    return null;
  };

  return (
    <div className="auth-page">
      <div className="auth-card auth-card-wide animate-fade-up">
        <div className="auth-logo">
          <span className="logo-dji">DJI</span>
          <span className="logo-nepal">Nepal</span>
        </div>
        <h1 className="auth-title">Create Account</h1>
        <p className="auth-sub text-muted">Join DJI Nepal — the #1 drone store in Nepal</p>

        <form onSubmit={handleSubmit} className="auth-form">
          <div className="grid-2">
            <div className="form-group">
              <label className="form-label">First Name</label>
              <input name="first_name" type="text" placeholder="Hari" value={form.first_name} onChange={handleChange} />
            </div>
            <div className="form-group">
              <label className="form-label">Last Name</label>
              <input name="last_name" type="text" placeholder="Prasad" value={form.last_name} onChange={handleChange} />
            </div>
          </div>

          <div className="form-group">
            <label className="form-label">Username *</label>
            <div className="input-icon-wrap">
              <FiUser className="input-icon" />
              <input
                name="username" type="text" placeholder="hariprasad123"
                value={form.username} onChange={handleChange}
                onBlur={() => checkField('username')} required
              />
              <span className="input-suffix"><AvailIcon field="username" /></span>
            </div>
            {errors.username && <span className="form-error">{errors.username}</span>}
          </div>

          <div className="form-group">
            <label className="form-label">Email *</label>
            <div className="input-icon-wrap">
              <FiMail className="input-icon" />
              <input
                name="email" type="email" placeholder="hari@example.com"
                value={form.email} onChange={handleChange}
                onBlur={() => checkField('email')} required
              />
              <span className="input-suffix"><AvailIcon field="email" /></span>
            </div>
            {errors.email && <span className="form-error">{errors.email}</span>}
          </div>

          <div className="form-group">
            <label className="form-label">Phone (Nepal)</label>
            <div className="input-icon-wrap">
              <FiPhone className="input-icon" />
              <input name="phone" type="tel" placeholder="98XXXXXXXX" value={form.phone} onChange={handleChange} />
            </div>
          </div>

          <div className="form-group">
            <label className="form-label">Password *</label>
            <div className="input-icon-wrap">
              <FiLock className="input-icon" />
              <input
                name="password" type={showPw ? 'text' : 'password'}
                placeholder="Min. 6 characters" value={form.password}
                onChange={handleChange} required
              />
              <button type="button" className="pw-toggle" onClick={() => setShowPw(!showPw)}>
                {showPw ? <FiEyeOff /> : <FiEye />}
              </button>
            </div>
            {errors.password && <span className="form-error">{errors.password}</span>}
          </div>

          <button type="submit" className="btn btn-primary btn-lg auth-btn" disabled={loading}>
            {loading ? 'Creating Account...' : 'Create Account'}
          </button>
        </form>

        <p className="auth-switch">
          Already have an account? <Link to="/signin">Sign In</Link>
        </p>
      </div>
    </div>
  );
};

export default SignUp;
